// src/services/rhAdminService.js
import { apiService } from './api';

export const rhAdminService = {
  // Récupérer toutes les demandes RH de l'entreprise
  getRequests: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.status && filters.status !== 'all') params.append('status', filters.status);
      if (filters.type && filters.type !== 'all') params.append('type', filters.type);
      if (filters.employeeId) params.append('employeeId', filters.employeeId);
      
      const url = `/rh/admin/requests${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await apiService.get(url);
      return response.data || [];
    } catch (error) {
      console.error('❌ Erreur getRequests RH:', error);
      throw error;
    }
  },

  // Récupérer une demande spécifique
  getRequestById: async (requestId) => {
    try {
      const response = await apiService.get(`/rh/admin/requests/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur getRequestById:', error);
      throw error;
    }
  },

  // Approuver une demande
  approveRequest: async (requestId, responseMessage, documentFile = null) => {
    try {
      let response;
      
      if (documentFile) {
        const formData = new FormData();
        formData.append('status', 'approved');
        formData.append('responseMessage', responseMessage || '');
        formData.append('document', documentFile);
        
        const token = localStorage.getItem('authToken');
        response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/rh/admin/requests/${requestId}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });
        response = await response.json();
      } else {
        response = await apiService.put(`/rh/admin/requests/${requestId}`, {
          status: 'approved',
          responseMessage: responseMessage || ''
        });
      }
      
      return response;
    } catch (error) {
      console.error('❌ Erreur approveRequest:', error);
      throw error;
    }
  },

  // Refuser une demande
  rejectRequest: async (requestId, responseMessage) => {
    try {
      const response = await apiService.put(`/rh/admin/requests/${requestId}`, {
        status: 'rejected',
        responseMessage: responseMessage || ''
      });
      return response;
    } catch (error) {
      console.error('❌ Erreur rejectRequest:', error);
      throw error;
    }
  },

  // Marquer comme en traitement
  markAsProcessing: async (requestId) => {
    try {
      const response = await apiService.put(`/rh/admin/requests/${requestId}`, {
        status: 'processing'
      });
      return response;
    } catch (error) {
      console.error('❌ Erreur markAsProcessing:', error);
      throw error;
    }
  },

  // Supprimer une demande
  deleteRequest: async (requestId) => {
    try {
      const response = await apiService.delete(`/rh/admin/requests/${requestId}`);
      return response;
    } catch (error) {
      console.error('❌ Erreur deleteRequest:', error);
      throw error;
    }
  },

  // Statistiques RH
  getStats: async () => {
    try {
      const response = await apiService.get('/rh/admin/stats');
      return response.data || {};
    } catch (error) {
      console.error('❌ Erreur getStats:', error);
      return {
        total: 0,
        pending: 0,
        approved: 0,
        rejected: 0,
        processing: 0,
        byType: {}
      };
    }
  }
};